import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { DestinationUrlAction } from './destination-url-action';
import { CustomEventAction } from './custom-event-action';

export const goalType = {
  DestinationGoal: {
    glyph: 'ba-Link',
    name: _TL_('Destination URL'),
  },
  EventGoal: {
    glyph: 'ba-Click',
    name: _TL_('Custom event'),
  },
};

const getValueErrorMessage = (i18n, max, value) => {
  if (_.size(value) === 0) {
    return i18n.getString(_TL_('Enter a value'));
  } else if (value.length > max) {
    return i18n.getString(_TL_('Please provide a value with less than {{max}} characters'), { max });
  }
  return undefined;
};

export const GoalActionForm = (props) => {
  const {
    goals,
    eventType,
    actionOperator,
    onChangeActionOperator,
    url,
    onURLChange,
    action,
    onActionChange,
    onNotifyValidationResult,
    urlExpressionOperators,
  } = props;

  const onActionOperatorChange = useCallback(option => onChangeActionOperator(option.key), [onChangeActionOperator]);

  const goalAction = useMemo(() => {
    if (eventType === 'DestinationGoal') {
      return (<DestinationUrlAction
        goals={goals}
        getValueErrorMessage={getValueErrorMessage}
        url={url}
        onURLChange={onURLChange}
        onNotifyValidationResult={onNotifyValidationResult}
        expressionOperator={actionOperator}
        onExpressionOperatorChange={onActionOperatorChange}
        urlExpressionOperators={urlExpressionOperators}
      />);
    }
    return (<CustomEventAction
      goals={goals}
      getValueErrorMessage={getValueErrorMessage}
      action={action}
      onActionChange={onActionChange}
      onNotifyValidationResult={onNotifyValidationResult}
      actionOperator={actionOperator}
      onActionOperatorChange={onActionOperatorChange}
    />);
  }, [eventType, goals, action, onActionChange, onNotifyValidationResult, actionOperator, onActionOperatorChange, url, onURLChange, urlExpressionOperators]);

  return (goalAction);
};

GoalActionForm.propTypes = {
  goals: PropTypes.arrayOf(PropTypes.shape({
    action: PropTypes.string,
    actionOperator: PropTypes.string,
    expressionOperator: PropTypes.string,
    url: PropTypes.string,
  })),
  eventType: PropTypes.oneOf(['DestinationGoal', 'EventGoal']),
  actionOperator: PropTypes.string.isRequired,
  onChangeActionOperator: PropTypes.func.isRequired,
  url: PropTypes.string,
  onURLChange: PropTypes.func.isRequired,
  action: PropTypes.string,
  onActionChange: PropTypes.func.isRequired,
  onNotifyValidationResult: PropTypes.func,
  urlExpressionOperators: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
};
GoalActionForm.defaultProps = {
  goals: undefined,
  onNotifyValidationResult: null,
  url: '',
  action: '',
  actionOperator: 'EqualsTo',
  eventType: undefined,
};
